import React from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import PendingAthletes from './components/PendingAthletes';
import PendingOnboarding from './components/PendingOnboarding';
import PendingWorkouts from './components/PendingWorkouts';
import PendingModeration from './components/PendingModeration';
import Competitions from './components/Competitions';
import Referrals from './components/Referrals';
import PendingPayments from './components/PendingPayments';
import Agents from './components/Agents';
import AgentPayouts from './components/AgentPayouts';
import AuthStatus from './components/AuthStatus';

function App() {
  const user = useSelector((state) => state.auth.user);

  const RequireAuth = ({ children }) => (user ? children : <AuthStatus />);

  return (
    <Router>
      {user ? (
        <Layout>
          <Routes>
            <Route path="/" element={<Navigate to="/athletes" replace />} />
            <Route path="/athletes" element={<RequireAuth><PendingAthletes /></RequireAuth>} />
            <Route path="/onboarding" element={<RequireAuth><PendingOnboarding /></RequireAuth>} />
            <Route path="/workouts" element={<RequireAuth><PendingWorkouts /></RequireAuth>} />
            <Route path="/moderation" element={<RequireAuth><PendingModeration /></RequireAuth>} />
            <Route path="/referrals" element={<RequireAuth><Referrals /></RequireAuth>} />
            <Route path="/payments" element={<RequireAuth><PendingPayments /></RequireAuth>} />
            <Route path="/competitions" element={<RequireAuth><Competitions /></RequireAuth>} />
            <Route path="/agents" element={<RequireAuth><Agents /></RequireAuth>} />
            <Route path="/agent-payouts" element={<RequireAuth><AgentPayouts /></RequireAuth>} />
            <Route path="*" element={<Navigate to="/athletes" replace />} />
          </Routes>
        </Layout>
      ) : (
        <Routes>
          <Route path="*" element={<AuthStatus />} />
        </Routes>
      )}
    </Router>
  );
}

export default App;
